import { Component, OnInit } from '@angular/core';
import { PermissionManagementService } from './permission-management.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';

export const columns = [
  { key: 'title', name: 'PERMISSION_TITLE_EN', visible: true },
  { key: 'titleEn', name: 'PERMISSION_TITLE_ZH', visible: true },
  { key: 'name', name: 'PERMISSION_NAME', visible: true },
  { key: 'icon', name: 'PERMISSION_ICON', visible: true },
  { key: 'url', name: 'PERMISSION_URL', visible: true },
  { key: 'type', name: 'PERMISSION_TYPE', visible: true },
  { key: 'menuHidden', name: 'MENU_HIDDEN', visible: true },
  { key: 'menuOrder', name: 'MENU_ORDER', visible: true },
];

@Component({
  selector: 'app-permission-management',
  templateUrl: './permission-management.component.html',
  styleUrls: ['./permission-management.component.scss']
})
export class PermissionManagementComponent implements OnInit {

  dataSource: any[] = [];
  columns: any[] = columns;
  widthConfig = ['230px','220px','220px','150px','150px','130px','130px','160px','120px'];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  isVisible = false;
  validateModuleForm!: FormGroup;
  isSpinning = false;
  iconList = [
    'grid-view',
    'cube',
    'daily-sign',
    'setting',
    'log-out',
    'left-arrow',
    'right-arrow',
    'bottom-arrow',
    'top-arrow',
    'search',
    'clock',
    'upload',
    'download',
    'menu',
    'alarm',
    'close',
    'sun',
    'mail',
    'card',
    'dashboard',
    'calendar',
    'double-circle',
    'long-arrow',
    'square-plus',
    'big-plus',
    'user',
    'security-user',
    'user-mechanic',
    'user-warning',
    'binary-desktop',
    'settings-arrows',
    'book-lightbulb',
    'structure-settings',
    'operation-log',
    'technical-service',
  ];

  constructor(
    private service: PermissionManagementService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.getList();
    this.validateModuleForm = this.fb.group({
      id: [0, []],
      parentId: [0, []],
      icon: [null, [Validators.required]],
      menuHidden: ['Y', []],
      menuOrder: [null, [Validators.required, Validators.pattern(/^\d*$/)]],
      name: [null, [Validators.required]],
      permissionCode: [null, [Validators.required]],
      title: [null, [Validators.required]],
      titleEn: [null, [Validators.required]],
      type: ['MENU', []],
      url: [null, [Validators.required]],
    });
  }

  getList() {
    this.isSpinning = true;
    this.service.getPermissionList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        this.dataSource = rtnData;
      }
      this.isSpinning = false;
    });
  }

  onEdit(row: any) {
    this.isSpinning = true;
    this.service.addOrUpdate(row).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
    this.resetForm();
  }

  onDelete(row: any) {
    this.isSpinning = true;
    this.service.delete(row.id).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onEditPermission(row: any) {
    this.isVisible = true;
    const { id = 0, icon, menuHidden, menuOrder, name, parentId = 0, permissionCode, title, type, url, titleEn = "" } = row;
    this.validateModuleForm.setValue({
      id, icon, menuHidden, menuOrder, name, parentId, permissionCode, title, type, url, titleEn
    });
  }

  onAddSubPermission(row: any) {
    this.isVisible = true;
    this.validateModuleForm.setValue({
      id: 0,
      parentId: row.id,
      icon: null,
      menuHidden: 'Y',
      menuOrder: null,
      name: null,
      permissionCode: null,
      title: null,
      titleEn: null,
      type: 'MENU',
      url: null,
    });
  }

  onSave() {
    if (this.validateModuleForm.valid) {
      this.isVisible = false;
      this.onEdit(this.validateModuleForm.value);
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onCancel() {
    this.validateModuleForm.reset();
    this.resetForm();
    this.isVisible = false;
  }

  resetForm() {
    this.validateModuleForm.setValue({
      id: 0,
      parentId: 0,
      icon: null,
      menuHidden: 'Y',
      menuOrder: null,
      name: null,
      permissionCode: null,
      title: null,
      titleEn: null,
      type: 'MENU',
      url: null,
    });
  }

  collapse() {

  }
}
